import { useContext } from 'react'
import { useSyncExternalStore } from 'react'
import { Session } from './AuthClient'
import { AuthContext } from './AuthProvider'

export const useSession = (): Session => {
  const store = useContext(AuthContext)
  if (!store) throw new Error('useSession must be used within <SessionProvider>')

  const session = useSyncExternalStore(store.subscribe, store.get, store.get)

  return session as Session
}
